module.exports = __webpack_public_path__ + "static/img/wei_guan.ebc6fe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/wei_guan.jpg
// module id = /92h
// module chunks = 12